(() => {
  'use strict';

  function initGallery(root) {
    const mainImage = root.querySelector('[data-pdp-main-image]');
    const thumbs = root.querySelectorAll('[data-pdp-thumb]');
    if (!mainImage || thumbs.length === 0) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.getAttribute('data-pdp-thumb');
        if (!src) return;
        mainImage.src = src;
        mainImage.removeAttribute('srcset');
        const zoom = thumb.getAttribute('data-pdp-zoom');
        if (zoom) mainImage.setAttribute('data-pdp-zoom', zoom);
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        mainImage.classList.remove('is-zoomed');
        mainImage.style.transformOrigin = 'center center';
        const media = mainImage.closest('.decades-pdp__media');
        if (media) media.classList.remove('is-magnify');
      });
    });
  }

  function initZoom(root) {
    const media = root.querySelector('.decades-pdp__media');
    const img = root.querySelector('[data-pdp-main-image]');
    if (!media || !img) return;

    // Click toggles magnify mode; while armed, hovering pans a magnified view of the
    // region under the cursor. The .decades-pdp__media frame clips the scaled image.
    const upgrade = () => {
      const hi = img.getAttribute('data-pdp-zoom');
      if (hi && img.getAttribute('src') !== hi) {
        img.removeAttribute('srcset');
        img.setAttribute('src', hi);
      }
    };
    const track = (e) => {
      const r = img.getBoundingClientRect();
      const x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
      const y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
      img.style.transformOrigin = x + '% ' + y + '%';
    };
    const reset = () => {
      img.classList.remove('is-zoomed');
      img.style.transformOrigin = 'center center';
    };

    media.addEventListener('click', (e) => {
      if (media.classList.toggle('is-magnify')) {
        upgrade();
        track(e);
        img.classList.add('is-zoomed');
      } else {
        reset();
      }
    });
    media.addEventListener('mousemove', (e) => {
      if (!media.classList.contains('is-magnify')) return;
      track(e);
      img.classList.add('is-zoomed');
    });
    media.addEventListener('mouseleave', reset);
  }

  function makeMoneyFormatter(sampleText) {
    const m = String(sampleText || '$0.00').match(/^(\D*)([\d.,]+)(\D*)$/);
    const prefix = m ? m[1] : '$';
    const suffix = m ? m[3] : '';
    const numPart = m ? m[2] : '0.00';
    const dec = /[.,]\d{2}$/.test(numPart) ? 2 : 0;
    return (cents) =>
      prefix + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suffix;
  }

  function initBuyBox(root) {
    const form = root.querySelector('[data-pdp-form], #decades-pdp-form');
    if (!form) return;

    let variants = [];
    const dataEl = root.querySelector('[data-pdp-variant-data]');
    if (dataEl) {
      try {
        variants = JSON.parse(dataEl.textContent) || [];
      } catch (e) {
        variants = [];
      }
    }

    const idInput = form.querySelector('[data-pdp-variant-input]');
    const optionSelects = Array.from(form.querySelectorAll('[data-pdp-option]'));
    const atc = form.querySelector('[data-pdp-atc]');
    const buyNow = form.querySelector('[data-pdp-buynow]');
    const displayPrice = root.querySelector('[data-pdp-display-price]');
    const qtyInput = form.querySelector('[data-pdp-qty]');
    const stockEl = root.querySelector('[data-pdp-stock]');
    const fmt = makeMoneyFormatter((variants[0] && variants[0].priceText) || '$0.00');

    let current = variants[0] || null;
    function qty() {
      const v = parseInt(qtyInput && qtyInput.value, 10);
      return isNaN(v) || v < 1 ? 1 : v;
    }

    function findVariant() {
      if (optionSelects.length === 0) return variants[0] || null;
      const chosen = optionSelects.map((s) => s.value);
      return (
        variants.find(
          (v) => Array.isArray(v.options) && v.options.length === chosen.length && v.options.every((o, i) => o === chosen[i])
        ) || null
      );
    }

    function render() {
      if (current) {
        if (idInput) idInput.value = current.id;
        const lineText = fmt(current.price * qty());
        if (displayPrice) {
          if (current.compare && current.compare > current.price) {
            displayPrice.innerHTML =
              '<s class="decades-pdp__price-compare">' + fmt(current.compare * qty()) + '</s> ' + lineText;
          } else {
            displayPrice.textContent = lineText;
          }
        }
        const stickyPrice = document.querySelector('[data-pdp-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = lineText;
      }
      if (stockEl) {
        const out = current ? current.available === false : false;
        stockEl.textContent = out ? 'Out of stock' : 'In Stock';
        stockEl.classList.toggle('is-out', out);
      }
      if (atc) {
        const sold = current ? current.available === false : false;
        atc.disabled = sold;
        const text = atc.querySelector('[data-pdp-atc-text]');
        if (text) text.textContent = sold ? 'Sold out' : (atc.dataset.originalText || 'Add to Cart');
        if (buyNow) buyNow.disabled = sold;
      }
    }

    optionSelects.forEach((sel) => sel.addEventListener('change', () => { current = findVariant(); render(); }));

    if (qtyInput) {
      qtyInput.addEventListener('change', render);
      qtyInput.addEventListener('input', render);
    }

    if (buyNow) {
      buyNow.addEventListener('click', () => {
        if (buyNow.disabled) return;
        const r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        buyNow.disabled = true;
        fetch(r + 'cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(() => { window.location.href = r + 'checkout'; })
          .catch(() => { buyNow.disabled = false; });
      });
    }
    render();
  }

  function initSticky(root) {
    const bar = root.querySelector('[data-pdp-sticky]');
    const atc = root.querySelector('[data-pdp-atc]');
    const stickyBtn = root.querySelector('[data-pdp-sticky-atc]');
    const form = root.querySelector('[data-pdp-form], #decades-pdp-form');
    if (!bar || !atc) return;

    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', () => {
        const booster = typeof BoosterTheme !== 'undefined' ? BoosterTheme : (window.BoosterTheme || null);
        if (booster && booster.cart && typeof booster.cart.addToCart === 'function') {
          booster.cart.addToCart(false, form);
        } else if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    }

    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const show = !entry.isIntersecting;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      },
      { threshold: 0 }
    );
    observer.observe(atc);
  }

  function initFbt(root) {
    const fbt = root.querySelector('[data-pdp-fbt]');
    if (!fbt) return;
    const cards = Array.from(fbt.querySelectorAll('[data-fbt-item]'));
    const totalEl = fbt.querySelector('[data-fbt-total]');
    const addBtn = fbt.querySelector('[data-fbt-add]');
    const fmt = makeMoneyFormatter(totalEl ? totalEl.textContent : '$0.00');

    function itemOf(card) {
      try { return JSON.parse(card.getAttribute('data-fbt-item')); } catch (e) { return null; }
    }
    function recalc() {
      let sum = 0;
      cards.forEach((c) => {
        const cb = c.querySelector('[data-fbt-checkbox]');
        const it = itemOf(c);
        if (cb && cb.checked && it) sum += it.price;
      });
      if (totalEl) totalEl.textContent = fmt(sum);
    }
    cards.forEach((c) => {
      const cb = c.querySelector('[data-fbt-checkbox]');
      if (cb && !cb.disabled) {
        cb.addEventListener('change', () => {
          c.classList.toggle('is-unchecked', !cb.checked);
          recalc();
        });
      }
    });
    if (addBtn) {
      let busy = false;
      addBtn.addEventListener('click', () => {
        if (busy) return;
        const items = [];
        cards.forEach((c) => {
          const cb = c.querySelector('[data-fbt-checkbox]');
          const it = itemOf(c);
          if (cb && cb.checked && it) items.push({ id: it.id, quantity: 1 });
        });
        if (!items.length) return;
        busy = true;
        addBtn.disabled = true;
        const reset = () => { busy = false; addBtn.disabled = false; };
        const booster = typeof BoosterTheme !== 'undefined' ? BoosterTheme : (window.BoosterTheme || null);
        if (booster && booster.cart && typeof booster.cart.addToCartJSON === 'function') {
          booster.cart.addToCartJSON(false, { items: items });
          setTimeout(reset, 1500);
        } else {
          const r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(r + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items }),
          })
            .then(() => { if (booster && booster.events) { try { booster.events.trigger('booster:content:update'); } catch (e) {} } })
            .finally(reset);
        }
      });
    }
    recalc();
  }

  function initCarousel(root) {
    const car = root.querySelector('[data-pdp-carousel]');
    if (!car) return;
    const track = car.querySelector('[data-carousel-track]');
    const prev = car.querySelector('[data-carousel-prev]');
    const next = car.querySelector('[data-carousel-next]');
    const nav = car.querySelector('.decades-pdp__carousel-nav');
    const productId = car.getAttribute('data-pdp-carousel-product');
    const sampleEl = root.querySelector('[data-pdp-onetime-price], [data-pdp-display-price]');
    const fmt = makeMoneyFormatter(sampleEl ? sampleEl.textContent : '$0.00');
    if (!track) return;

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    }
    function card(p) {
      let img = p.featured_image || (p.images && p.images[0]) || '';
      if (img) img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
      const url = typeof p.url === 'string' && p.url.charAt(0) === '/' ? p.url : '#';
      return (
        '<a class="decades-pdp__rec-card" href="' + esc(url) + '" role="listitem">' +
        '<span class="decades-pdp__rec-media">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="200" height="200">' : '') + '</span>' +
        '<span class="decades-pdp__rec-title">' + esc(p.title) + '</span>' +
        '<span class="decades-pdp__rec-rating jdgm-widget jdgm-preview-badge" data-id="' + esc(p.id) + '"></span>' +
        '<span class="decades-pdp__rec-price">' + fmt(p.price) + '</span>' +
        '</a>'
      );
    }
    function updateArrows() {
      if (!nav) return;
      const scrollable = track.scrollWidth > track.clientWidth + 4;
      nav.classList.toggle('is-hidden', !scrollable);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    function step(dir) {
      const c = track.querySelector('.decades-pdp__rec-card');
      const w = c ? c.getBoundingClientRect().width + 16 : 240;
      track.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    function finalize() {
      if (!track.children.length) { car.style.display = 'none'; return; }
      if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') { try { window.jdgm.customizeBadges(); } catch (e) {} }
      updateArrows();
    }
    if (productId) {
      const r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(r + 'recommendations/products.json?product_id=' + productId + '&limit=12&intent=related')
        .then((res) => (res.ok ? res.json() : null))
        .then((data) => {
          const prods = (data && data.products) || [];
          if (prods.length) track.innerHTML = prods.map(card).join('');
          finalize();
        })
        .catch(finalize);
    } else {
      finalize();
    }
  }

  function initAppstleQty(root) {
    const qtyInput = root.querySelector('[data-pdp-qty]');
    if (!qtyInput) return;
    const WID = '#appstle_subscription_widget0';
    const SEL = WID + ' .appstle_subscription_amount, ' + WID + ' .appstle_subscription_compare_amount';
    let fmt = null;
    function parseAmount(t) {
      const m = String(t).match(/([\d,]+\.?\d*)/);
      return m ? parseFloat(m[1].replace(/,/g, '')) : null;
    }
    function currentQty() {
      const v = parseInt(qtyInput.value, 10);
      return isNaN(v) || v < 1 ? 1 : v;
    }
    let observer = null;
    let widgetEl = null;
    function apply() {
      const els = root.querySelectorAll(SEL);
      if (!els.length) return;
      const q = currentQty();
      if (observer) observer.disconnect();
      els.forEach((el) => {
        if (el.dataset.appstleBase == null) {
          const amt = parseAmount(el.textContent);
          if (amt == null) return;
          el.dataset.appstleBase = String(amt);
          if (!fmt) fmt = makeMoneyFormatter(el.textContent.trim());
        }
        const base = parseFloat(el.dataset.appstleBase);
        if (isNaN(base)) return;
        if (!fmt) fmt = makeMoneyFormatter('$0.00');
        const want = fmt(Math.round(base * 100) * q);
        if (el.textContent.trim() !== want) el.textContent = want;
      });
      if (observer && widgetEl) observer.observe(widgetEl, { subtree: true, childList: true, characterData: true });
    }
    qtyInput.addEventListener('input', apply);
    qtyInput.addEventListener('change', apply);
    let tries = 0;
    const iv = setInterval(() => {
      const widget = document.querySelector(WID);
      tries += 1;
      if (widget && root.querySelectorAll(SEL).length) {
        clearInterval(iv);
        widgetEl = widget;
        observer = new MutationObserver(() => apply());
        apply();
      } else if (tries > 40) {
        clearInterval(iv);
      }
    }, 300);
  }

  function initAssurances(root) {
    const list = root.querySelector('.decades-pdp__assurances');
    const atc = root.querySelector('[data-pdp-atc]');
    if (!list || !atc || !atc.parentNode) return;
    const form = atc.parentNode;
    function place() {
      if (atc.previousElementSibling !== list) form.insertBefore(list, atc);
    }
    place();
    new MutationObserver(place).observe(form, { childList: true });
  }

  function initDetails(root) {
    const body = root.querySelector('[data-pdp-details-body]');
    const toggle = root.querySelector('[data-pdp-details-toggle]');
    if (!body || !toggle) return;

    // Only collapse when the description is long enough to be worth truncating (~600 chars).
    if ((body.textContent || '').trim().length <= 600) return;

    body.classList.add('is-collapsed');
    toggle.hidden = false;
    toggle.setAttribute('aria-expanded', 'false');

    const label = toggle.querySelector('[data-pdp-details-label]') || toggle;
    toggle.addEventListener('click', () => {
      const collapsed = body.classList.toggle('is-collapsed');
      toggle.classList.toggle('is-open', !collapsed);
      toggle.setAttribute('aria-expanded', String(!collapsed));
      label.textContent = collapsed ? 'READ MORE' : 'READ LESS';
    });
  }

  function initReviews(root) {
    const heading = root.querySelector('#DecadesPdpReviews');
    const section = root.querySelector('#decades-reviews');
    if (!heading || !section) return;
    const widget = section.querySelector('.jdgm-review-widget') || section;

    function reviewCount() {
      const w = widget.querySelector('.jdgm-rev-widg');
      if (w && w.hasAttribute('data-number-of-reviews')) {
        const n = parseInt(w.getAttribute('data-number-of-reviews'), 10);
        return isNaN(n) ? null : n;
      }
      if (widget.querySelectorAll('.jdgm-rev').length > 0) return widget.querySelectorAll('.jdgm-rev').length;
      if (/be the first to write a review|no reviews/i.test(widget.textContent || '')) return 0;
      return null;
    }
    function apply() {
      const c = reviewCount();
      if (c === null) return false;
      heading.hidden = c === 0;
      return true;
    }

    if (apply()) return;
    let tries = 0;
    const iv = setInterval(() => { tries += 1; if (apply() || tries > 50) clearInterval(iv); }, 250);
    try {
      new MutationObserver(() => apply()).observe(widget, { childList: true, subtree: true });
    } catch (e) {}
  }

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-decades-pdp]');
    if (!root) return;
    initGallery(root);
    initZoom(root);
    initBuyBox(root);
    initFbt(root);
    initCarousel(root);
    initSticky(root);
    initAppstleQty(root);
    initAssurances(root);
    initDetails(root);
    initReviews(root);
  });
})();
